import { QueryClient } from '@tanstack/react-query';

// QueryClient global. Cada feature puede sumar manejo de errores específico vía
// MutationCache/QueryCache si lo necesita; el template arranca con lo mínimo.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // No reintentar errores de auth / permisos / validación.
        const status = (error as { response?: { status?: number } }).response?.status;
        if (status === 401 || status === 403 || status === 404 || status === 422) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
